import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { pick, useSite } from "../useSite";

export default function Enquire() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    packageTitle: params.get("journey") || "",
    travelers: "2",
    travelDate: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const { block } = useSite();
  const contact = pick(block("contact"), {
    title: "We would love to hear from you",
    subtitle: "Contact",
    body: "info@vishmitravels.com · +94 76784 5585",
  }) || {};

  function set(key, value) {
    setForm((current) => ({ ...current, [key]: value }));
  }

  async function onSubmit(event) {
    event.preventDefault();
    setError("");
    setStatus("");
    try {
      await api("/api/inquiries", { method: "POST", body: JSON.stringify(form) });
      setStatus("Thank you. A planner at Vishmi Travels will write back shortly.");
      setForm({ ...form, message: "" });
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <Layout>
      <Seo
        title="Enquire"
        description="Tell Vishmi Travels how you want your Sri Lanka journey to feel. We reply from info@vishmitravels.com."
        path="/enquire"
      />
      <header className="page-hero">
        <div className="wrap">
          {contact.subtitle ? <p className="eyebrow">{contact.subtitle}</p> : null}
          {contact.title ? <h1>{contact.title}</h1> : null}
          {contact.body ? <p>{contact.body}</p> : null}
        </div>
      </header>
      <section className="section cream">
        <div className="wrap">
          <form className="form" onSubmit={onSubmit}>
            <label>Name<input required value={form.name} onChange={(e) => set("name", e.target.value)} /></label>
            <label>Email<input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} /></label>
            <label>Phone<input value={form.phone} onChange={(e) => set("phone", e.target.value)} /></label>
            <label>Journey<input value={form.packageTitle} onChange={(e) => set("packageTitle", e.target.value)} /></label>
            <label>Travelers<input value={form.travelers} onChange={(e) => set("travelers", e.target.value)} /></label>
            <label>When<input value={form.travelDate} onChange={(e) => set("travelDate", e.target.value)} placeholder="March 2027" /></label>
            <label>How do you want the trip to feel?<textarea required value={form.message} onChange={(e) => set("message", e.target.value)} /></label>
            <button className="btn" type="submit">Send enquiry</button>
            {status ? <p className="notice">{status}</p> : null}
            {error ? <p className="error">{error}</p> : null}
          </form>
        </div>
      </section>
    </Layout>
  );
}
